import i18n from '@signavio/i18n'
import { applicationName } from '@signavio/effektif-commons'

import SneakPeek from './SneakPeek'
import { useFeature } from '../../hooks'

export type FeatureProps = {
  feature: string
  inverse?: boolean
  children: React.ReactNode
  sneakPeek?: boolean
  hint?: string
  tooltipPlacement?: PositionT
  tooltip?: string | React.ReactNode
}

function Feature({
  feature,
  inverse,
  sneakPeek,
  tooltip,
  tooltipPlacement,
  hint,
  children,
}: FeatureProps) {
  const featureAvailable = useFeature(feature) || !feature
  const shouldHaveFeature = featureAvailable && !inverse
  const shouldNotHaveFeature = !featureAvailable && inverse

  if (shouldHaveFeature || shouldNotHaveFeature) {
    return <>{children}</>
  }

  if (sneakPeek) {
    return <SneakPeek hint={getHint(hint)}>{children}</SneakPeek>
  }

  if (tooltip) {
    return (
      <SneakPeek tooltip={tooltip} tooltipPlacement={tooltipPlacement}>
        {children}
      </SneakPeek>
    )
  }

  return null
}

const getHint = (hint?: string) =>
  hint ||
  i18n(
    'Unfortunately this feature is not included in your version of __applicationName__.',
    { applicationName }
  )

export default Feature
